module.exports = __webpack_public_path__ + "media/images/checkmark-cc137310.png";